// Signature Requests — View opens EZ-Sign; the backend names it as the `esign` page.
export function canSeeSignatureRequests(
  pages: readonly string[] | undefined
): boolean {
  return pages?.includes("esign") === true
}
